import './index.scss'

import { useNavigate } from 'react-router-dom'

import { ChurchService } from '@interfaces/service.interface'
import { RoutedService, servicePagePath } from '../DetailsPage'

// The service list the Library and a series' page share, so the two read the
// same. Pages using it take the `services-page` class for its styles.
export default function ServiceList(props: {
  services: ChurchService[];
  // Where a service's page should go Back to, when that isn't the list the
  // service is filed in.
  backLocation?: string;
}) {
  return <ol className='services-list'>
    {props.services.map((service) => <ServiceRow
      key={service.id}
      service={service}
      backLocation={props.backLocation} />)}
  </ol>
}

function ServiceRow(props: { service: ChurchService; backLocation?: string }) {
  const navigate = useNavigate();
  const attributes = props.service.attributes;
  const date = parseDate(attributes.timestamp);
  const isUpcoming = date !== null && date.getTime() > Date.now();
  const songCount = attributes.songs?.length ?? 0;

  return <li><button
    type='button'
    className='service-row'
    onClick={() => {
      const state: RoutedService = { service: props.service, backLocation: props.backLocation };
      navigate(servicePagePath(props.service), { state });
    }}>
    <div className='service-thumbnail'>
      {attributes.thumbnailURL ?
        <img src={attributes.thumbnailURL} alt='' aria-hidden='true' /> :
        <span className='thumbnail-fallback' aria-hidden='true'>{(attributes.title || '?').slice(0, 1)}</span>}
    </div>

    <div className='service-body'>
      <h3>{attributes.title || 'Untitled Service'}</h3>

      {date ? <p className='service-date'>{formatDate(date)}</p> : null}

      <div className='service-tags'>
        {isUpcoming ? <span className='service-tag upcoming'>Upcoming</span> : null}

        {songCount > 0 ? <span className='service-tag'>
          {songCount} {songCount === 1 ? 'song' : 'songs'}
        </span> : null}

        {/* Media, or the old single video link on services saved before it. */}
        {(attributes.media?.length ?? 0) > 0 || attributes.videoURL ?
          null :
          <span className='service-tag muted'>No media</span>}
      </div>
    </div>
  </button></li>
}

// Narrows a list already loaded by title or description, without asking the
// API for anything.
export function filterServices(services: ChurchService[], query: string) {
  const needle = query.trim().toLowerCase();

  if (needle.length === 0) {
    return services;
  }

  return services.filter((service) => {
    return (service.attributes.title ?? '').toLowerCase().includes(needle) ||
      (service.attributes.description ?? '').toLowerCase().includes(needle);
  });
}

// Timestamps arrive as ISO 8601. Anything unparseable is treated as absent
// rather than rendered as "Invalid Date".
function parseDate(value?: string | null) {
  if (!value) {
    return null;
  }

  const date = new Date(value);

  return Number.isNaN(date.getTime()) ? null : date;
}

function formatDate(date: Date) {
  return date.toLocaleString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: date.getFullYear() === new Date().getFullYear() ? undefined : 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  });
}
